import styled from "styled-components";

export const ChartExportWrapper = styled.div`
  width: 100%;
  .chart {
    margin-top: 10px;
    color: #00a8ff;
    font-weight: 700;
    font-size: 20px;
    border: 1px solid #bdc3c7;
    padding: 10px;
  }
`;
export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  img {
    width: 32px;
    height: auto;
    margin-right: 8px;
    fill: blue;
  }
  font-weight: bold;
  font-size: 16px;
`;
